/*
 * @Author: your name
 * @Date: 2021-12-30 15:40:25
 * @LastEditTime: 2022-05-27 14:44:48
 * @LastEditors: Please set LastEditors
 * @Description: 标注
 * @FilePath: \smart-community\src\components\map\js\modular\Marker.js
 */

import Feature from "ol/Feature";
import Point from "ol/geom/Point";
import {
  Circle,
  Circle as CircleStyle,
  Fill,
  Icon,
  Stroke,
  Style,
  Text
} from "ol/style";
// import （）

import { Cluster, Vector as VectorSource } from "ol/source";
import { Vector as VectorLayer } from "ol/layer";
import deviceIcon from "@/utils/deviceIcon";
// import { boundingExtent } from "ol/extent";
import handleCoordinates from "./handleCoordinates";
const { setPoint, setVideoPoint } = handleCoordinates();
let i = 1;
class Marker {
  distance = 40;
  minDistance = 20;
  source = undefined;
  constructor() {
    this.clusters = undefined;
    this.clusterSource = undefined;
  }

  // 创建图层
  createVector(myMap) {
    const self = this;
    self.source = new VectorSource({
      features: []
    });
    self.clusterSource = new Cluster({
      distance: parseInt(self.distance, 10),
      minDistance: parseInt(self.minDistance, 10),
      source: self.source
    });
    const vector = new VectorLayer({
      source: self.clusterSource,
      style: function(feature) {
        const style = self.markerStyle(feature);
        return style;
      }
    });
    myMap.on("click", e => {
      if (e.originalEvent.target.localName !== "canvas") {
        return;
      }
      self.clusters &&
        self.clusters.getFeatures(e.pixel).then((clickedFeatures, aa) => {

          if (clickedFeatures.length) {
            // Get clustered Coordinates
            const features = clickedFeatures[0].get("features");

            if (features.length >= 1) {
              const vslus = features[0].values_;
              vslus.click(features);
              // const extent = boundingExtent(
              //   features.map(r => r.getGeometry().getCoordinates())
              // );
              // myMap
              //   .getView()
              //   .fit(extent, { duration: 1000, padding: [1000, 1000, 1000, 1000] });
            }
          }
        });
    });
    return vector;
  }

  // 添加标注
  addMarker(myMap, data) {
    const { showType = 1 } = data;
    if (!data.id) {
      data.id = `${Date.now()}-${i++}`;
    }
    const self = this;
    const feature = new Feature({
      geometry: new Point(setPoint(data.location)),
      showType,
      ...data
    });
    feature.setId(data.id);
    if (!self.clusters) {
      self.clusters = self.createVector(myMap);
      myMap.addLayer(self.clusters);
    }
    self.source.addFeature(feature);
  }

  // 删除标注
  remMarker(id) {
    const self = this;
    const feature = self.source.getFeatureById(id);
    if (feature) self.source.removeFeature(feature);
  }

  // 清空标注
  clearMarker(myMap) {
    const self = this;
    if (!self.clusters) return
    return new Promise(resolve => {
      setTimeout(() => {
        myMap.removeLayer(self.clusters);
        self.clusters = undefined;
        resolve();
      }, 10);
    });
  }

  /**
   * 区域标注的样式
   */
  markerStyle(feature) {
    const features = feature.get("features");
    if (features.length > 1) {
      return new Style({
        image: new CircleStyle({
          radius: 16,
          stroke: new Stroke({
            color: "#fff"
          }),
          fill: new Fill({
            color: "#1f72f1"
          })
        }),
        text: new Text({
          text: features.length.toString(),
          font: "16px Calibri",
          fill: new Fill({
            color: "#fff"
          })
        })
      });
    }
    const form = features[0].values_;
    let icon = "";
    if (!form.poiType) {
      form.poiType = "default";
    }
    if (form.poiType in deviceIcon && deviceIcon[form.poiType].iconImg) {
      icon = deviceIcon[form.poiType].iconImg;
    } else if (form.poiType === "area") {
      icon = require(`@/assets/images/map/icon/timg.png`);
    }
    let style = {};
    if (form.showType === 2) {
      // 显示模型
      style = {
        image: new Icon({
          scale: 0.6,
          anchor: [0.5, 1], // 锚点
          anchorOrigin: "top-right", // 锚点源
          src: icon
        })
      };
    } else if (form.showType === 3) {
      // 显示名称
      style = {
        image: new Icon({
          scale: 0.6,
          anchor: [0.5, 1], // 锚点
          anchorOrigin: "top-right", // 锚点源
          src: icon,
          rotateWithView: true,
          rotation: form.rotation
        }),
        text: new Text({
          textAlign: "center", // 位置
          textBaseline: "middle", // 基准线
          font: "normal 16px 微软雅黑", // 文字样式
          text: form.name, // 文本内容
          offsetY: 15,
          fill: new Fill({
            // 文本填充样式（即文字颜色)
            color: form.info && form.info.patrolmanColor ? form.info.patrolmanColor : "#000"
          }),
          stroke: new Stroke({
            color: "#fff",
            width: 2
          }),
          rotateWithView: true,
          rotation: form.rotation
        })
      };
    } else if (form.showType === 1) {
      // 显示模型及名称
      style = {
        image: new Icon({
          // color: '#004eb9',
          // imgSize: [5, 5],
          scale: 0.6,
          anchor: [0.5, 0.5], // 锚点
          anchorOrigin: "top-right", // 锚点源
          src: icon
        }),
        text: new Text({
          textAlign: "center", // 位置
          textBaseline: "middle", // 基准线
          font: "normal 14px 微软雅黑", // 文字样式
          text: form.name, // 文本内容
          offsetY: -45,
          fill: new Fill({
            // 文本填充样式（即文字颜色)
            color: "#0f56c3"
          }),
          stroke: new Stroke({
            color: "#fff",
            width: 2
          })
        })
      };
    } else if (form.showType === 4) {
      // 名称
      style = {
        text: new Text({
          textAlign: "center", // 位置
          textBaseline: "middle", // 基准线
          font: "normal 14px 微软雅黑", // 文字样式
          text: form.name, // 文本内容
          offsetY: -20,
          fill: new Fill({
            // 文本填充样式（即文字颜色)
            color: form.info.color || "#0f56c3"
          }),
          stroke: new Stroke({
            color: "#fff",
            width: 2
          })
        })
      };
    }
    return new Style(style);
  }
}
export default Marker;